import { Provider } from '@angular/core';

import { ButtonPluginComponent } from './button-plugin/button-plugin.component';

export { ButtonPluginComponent };

export const Plugins: Provider[] = [
    ButtonPluginComponent
];



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/plugins/index.ts